export function Change($parse) {
  'ngInject';

  return {
    restrict: 'A',
    compile: function(element, attr) {
      const fn = $parse(attr.updChange);
      return function(scope, element) {
        element.on('change', e => {
          scope.$apply(() => {
            fn(scope, { $event: e });
          });
        });
      };
    },
  };
}
